import { Table, Anchor, IconArrowUp, IconArrowDown } from '@zillow/constellation';
import React from 'react';

var MortgageRateItem = function MortgageRateItem(_ref) {
  var _rate$link;
  var rate = _ref.rate,
    columns = _ref.columns,
    blockProps = _ref.blockProps;
  return /*#__PURE__*/React.createElement(Table.Row, blockProps, /*#__PURE__*/React.createElement(Table.Cell, null, rate !== null && rate !== void 0 && (_rate$link = rate.link) !== null && _rate$link !== void 0 && _rate$link.url ? /*#__PURE__*/React.createElement(Anchor, {
    href: rate.link.url,
    target: rate.link.opensInNewTab ? '_blank' : undefined
  }, rate.program) : rate.program), columns.includes('rate') && /*#__PURE__*/React.createElement(Table.Cell, null, rate.rate, "%"), columns.includes('rateChange') && /*#__PURE__*/React.createElement(Table.Cell, null, rate.isRateChangeUp ? /*#__PURE__*/React.createElement(IconArrowUp, {
    fontColor: 'red500',
    marginRight: "xs"
  }) : /*#__PURE__*/React.createElement(IconArrowDown, {
    fontColor: 'green500',
    marginRight: "xs"
  }), rate.rateChange, "%"), columns.includes('apr') && /*#__PURE__*/React.createElement(Table.Cell, null, rate.apr, "%"), columns.includes('aprChange') && /*#__PURE__*/React.createElement(Table.Cell, null, rate.isAprChangeUp ? /*#__PURE__*/React.createElement(IconArrowUp, {
    fontColor: 'red500',
    marginRight: "xs"
  }) : /*#__PURE__*/React.createElement(IconArrowDown, {
    fontColor: 'green500',
    marginRight: "xs"
  }), rate.aprChange, "%"));
};
var MortgageRateItem$1 = MortgageRateItem;

export { MortgageRateItem$1 as default };
